import { render, staticRenderFns } from "./carmonthchargerule.vue?vue&type=template&id=163d66ef&scoped=true&"
import script from "./carmonthchargerule.vue?vue&type=script&lang=js&"
export * from "./carmonthchargerule.vue?vue&type=script&lang=js&"
import style0 from "./carmonthchargerule.vue?vue&type=style&index=0&id=163d66ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d66ef",
  null
  
)

export default component.exports